export default {
    token: null,
    userInfo: null,
    tokenData: null,
    refreshToken: null,
    allData: {},
    lang: null
}